var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.646,
    viewBox: "0 0 20 20.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(0 20.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M19.2-12.046h-.767v-8.31a.289.289,0,0,0-.29-.29H5.838a.289.289,0,0,0-.29.29v1.467H4.267a.289.289,0,0,0-.29.29v1.467H2.7a.289.289,0,0,0-.289.29v3.131H.8a.808.808,0,0,0-.8.806V-.8A.8.8,0,0,0,.8,0H19.2A.8.8,0,0,0,20-.8V-11.242A.8.8,0,0,0,19.2-12.046ZM6.129-20.067H17.85v8.021h-.992V-18.6a.289.289,0,0,0-.289-.29H6.131v-1.177ZM4.556-18.31H16.277v6.265h-.992v-4.8a.289.289,0,0,0-.29-.29H4.558V-18.31ZM2.983-16.552H14.7v4.506H10.54a.376.376,0,0,1-.3-.152l-.823-1.123a.958.958,0,0,0-.769-.39H2.983ZM19.421-.8a.225.225,0,0,1-.225.225H.8A.225.225,0,0,1,.579-.8v-12.1A.225.225,0,0,1,.8-13.131H8.646a.376.376,0,0,1,.3.152l.823,1.123a.958.958,0,0,0,.769.39H19.2a.225.225,0,0,1,.225.225Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFull);
export default __webpack_public_path__ + "static/media/folderFull.8290d19fb26ae8ad2d2fa0ecbd234ff8.svg";
export { ForwardRef as ReactComponent };